import { render } from "./TableRevisao.vue?vue&type=template&id=95c9550e&scoped=true"
import script from "./TableRevisao.vue?vue&type=script&lang=js"
export * from "./TableRevisao.vue?vue&type=script&lang=js"

import "./TableRevisao.vue?vue&type=style&index=0&id=95c9550e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c9550e"]])

export default __exports__